import React, { useEffect, useState, useRef } from 'react';
import { Form, Input, Button, Space, Row, Col, Card, Select, InputNumber, message, Spin, Table, Tag, Typography, Drawer, Alert } from 'antd';
import { DeleteOutlined, EditOutlined, PlusOutlined } from '@ant-design/icons';
import { useClienti } from '../hooks/useClienti';
import { useStateContext } from '../../../../../contexts/ContextProvider';


const OfertaForm = ({ initialValues, onSubmit, onCancel, messageError }) => {
  const [form] = Form.useForm();
  const { user } = useStateContext();
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [messageApi, contextHolder] = message.useMessage();




  useEffect(() => {
    if (initialValues) {
      form.setFieldsValue(initialValues);
      if (initialValues.products) {
        setSelectedProducts(initialValues.products);
      }
    } else {
      // Setează manager-ul curent ca default și statusul draft
      const defaultValues = { 
        manager_id: user?.id,
        status: 1,
        amo_id: ""
      };
      form.setFieldsValue(defaultValues);
    }
  }, [initialValues, form, user]);

  const error = (message) => {
    messageApi.open({
      type: 'error',
      content: message,
    });
  };

  const handleSubmit = async (values) => {
    // Separăm produsele existente de cele noi
    const existingProducts = selectedProducts.filter(p => p.existing_product_id);
    const newProducts = selectedProducts.filter(p => !p.existing_product_id);
    
    const offerData = {
      ...values,
      existing_products: existingProducts, // Pentru a fi adăugate în ProdusToOferta
      new_products: newProducts, // Pentru a fi salvate în info
      client_mongo_id: null // Nu mai avem clientInfo din AMO
    };
    
    await onSubmit(offerData);
  };

  const handleCreateOfertaFromAmo = async () => {
    const amoId = form.getFieldValue('amo_id');
    if (!amoId) {
      error('Introdu ID-ul AMO pentru a continua');
      return;
    }

    // Creăm oferta direct cu AMO ID-ul
    const offerData = {
      amo_id: amoId,
      manager_id: user?.id,
      status: 1, // Draft
      notes: 'Ofertă creată din AMO CRM',
      existing_products: [],
      new_products: []
    };
    
    const success = await onSubmit(offerData);
    if (success) {
      message.success('Oferta a fost creată cu succes din AMO CRM!');
    }
  };



  
  return (
    <div> 
      {contextHolder}
      {messageError && <Alert message={messageError} type="error" />}
      <Form
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
        className="space-y-4"
    >
      <Card title="Import din AMO CRM" className="mb-4">
        <Row gutter={16} align="middle">
          <Col span={12}>
            <Form.Item
              name="amo_id"
              label="ID AMO"
              rules={[{ required: true, message: 'Introdu ID-ul AMO pentru a continua (cifre)' }]}
              className="mb-0"
            >
              <Input 
                placeholder="Introdu ID-ul din AMO CRM" 
                allowClear
                type="number"
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Button 
              type="primary" 
              onClick={handleCreateOfertaFromAmo}
              style={{ marginTop: '30px' }}
            >
              Crează Ofertă din AMO
            </Button>
          </Col>
        </Row>
      </Card>

      

      <Form.Item name="manager_id" hidden>
        <Input />
      </Form.Item>

      <div className="flex justify-end space-x-2 pt-4 border-t">
        <Button onClick={onCancel}>
          Anulează
        </Button>
      </div>
    </Form>
    </div>
  );
};

export default OfertaForm; 